<template>
  <div class="timetable content">
    <Row type="flex">
      <Col :lg="6" class="timetable__calendar">
        <v-calendar
          @update="setTitle"
        />

        <create-timeslot-form
          v-if="canAddNewTime"
          :sources="notarySources"
          @submit-new-slot="addNewSlot"
        />

        <span class="message--error" v-if="addDateError">{{
          addDateError[0]
        }}</span>
        <span class="message--error" v-if="sourceError">
          Укажите, где открыть запись.
        </span>
      </Col>

      <Col :lg="18" class="timetable__content">
        <Row
          type="flex"
          align="middle"
          justify="space-between"
          class="timetable__header"
        >
          <Col>
            <h3 class="title">{{ title }}</h3>
          </Col>
          <Col>
            <v-tag rounded color="gray" :text="getTagTitle()" />
          </Col>
        </Row>

        <div class="timetable__list">
          <list-header align="middle" type="timetable" />
          <template v-for="(item, index) in availableTimes">
            <template v-if="checkAppointmentByTime(item.datetime).length > 0">
              <user-card
                v-for="(user, userIndex) in checkAppointmentByTime(item.datetime)"
                type="timetable"
                :key="`user-${index}-${userIndex}`"
                :data="user"
              />
            </template>
            <Row
              class="timetable-card"
              :key="item.id"
            >
            <Col>
              <Row>
                <Col :span="6">
                 {{ item }}
                </Col>
                <Col :span="6">
                 {{ getSourceByTimeslotId(item.id) }}
                </Col>
                <Col :span="6">
                  <span
                    v-if="item.isOpen"
                    class="link"
                    @click="switchIsOpen(item, false)"
                    >Запись открыта</span
                  >
                  <span v-else class="link" @click="switchIsOpen(item, true)"
                    >Запись закрыта</span
                  >
                </Col>
                <Col :span="6">
                  <span
                    v-if="getAppointmentsByTimeSlot(item).length === 0"
                    class="link"
                    @click="deleteDateInterval(item.id, index)"
                  >Удалить слот</span>
              </Col>
              </Row>
              <Row>
                <Col>
                  <timeslot-timeline
                    :timeslot="item"
                    :freeSlots="freeTimeSlots[item.id]"
                    :appointments="getAppointmentsByTimeSlot(item)"
                  />
                </Col>
              </Row>
            </Col>
            </Row>

        </div>
      </Col>
    </Row>
  </div>
</template>

<script>
import VTag from "@/components/VTag";
import VIcon from "@/components/VIcon";
import ListHeader from "@/components/ListHeader";
import UserCard from "@/components/UserCard";
import VCalendar from "@/components/VCalendar";
import VField from "@/components/VField";
import CreateTimeslotForm from "@/components/CreateTimeslotForm";
import TimeslotTimeline from "@/components/TimeslotTimeline";
import AppointmentService from "@/services/AppointmentService";
import loadingMixin from "../mixins/loadingMixin";
import { getDecOfNoun, toISODate, toRUDate } from "@/utilities";
import { mapGetters, mapActions, mapState } from "vuex";


export default {
  name: "Timetable",


  components: {
    CreateTimeslotForm,
    TimeslotTimeline,
    VTag,
    UserCard,
    ListHeader,
    VCalendar,
    VField,
    VIcon
  },


  mixins: [loadingMixin],


  data() {
    return {
      selectedDate: new Date(),
      service: new AppointmentService(),
      title: "",
      modalIsVisible: false,
      freeTimeSlots: [],

      // TODO: a better error handling is needed
      addDateError: "",
      sourceError: "",
    };
  },


  computed: {
    ...mapGetters({
      user: "user/getUser"
    }),
    ...mapState(['appointmentSources']),

    notarySources() {
      return this.appointmentSources.filter(source => this.user.sources.includes(source.id))
    },

    canAddNewTime() {
      let today = new Date();
      return this.isToday(this.selectedDate) || this.selectedDate > today;
    },

    appointments() {
      return this.service.getAppointmentsByDate(
        toRUDate(this.selectedDate)
      );
    },

    timeSlots() {
      let dt = this.user.getGroupedAvailableDates(
        toRUDate(this.selectedDate)
      );

      if (dt && dt.length > 0) {
        return dt.sort((a, b) => a.start_datetime - b.start_datetime);
      }
      else {
        return dt;
      }
    },
  },


  async created() {
    await this.init();
  },


  methods: {
    ...mapActions(['getAppointmetSources']),

    async init() {
      this.loading = true;

      let promises = [
        this.service.getAppointmentsAll(),
        this.user.getAvailableDates(),
        this.user.getFreeTimeForSlots()
      ];

      if (this.appointmentSources.length === 0) {
        promises.push(this.getAppointmetSources());
      }

      let promisesResult = await Promise.all(promises);
      this.freeTimeSlots = promisesResult[2];

      this.loading = false;
    },

    isToday(someDate) {
      let today = new Date();
      return (
        someDate.getDate() === today.getDate() &&
        someDate.getMonth() === today.getMonth() &&
        someDate.getFullYear() === today.getFullYear()
      );
    },

    setTitle(date) {
      this.selectedDate = date.row;
      this.title = `${date.day}, ${date.weekDayLong}`;
    },

    getTagTitle() {
      return `${this.appointments.length} ${getDecOfNoun(
        this.appointments.length,
        ["заявка", "заявки", "заявок"]
      )}`;
    },

    getAppointmentsByTimeSlot(timeslot) {
      return this.appointments.length > 0
        ? this.appointments
            .filter(el => el.time_slot.id === timeslot.id)
            .sort((a, b) => a.datetime - b.datetime)
        : [];
    },

    getIndexOfTimeSlot(id) {
      return this.user.timetable.map(el => el.id).indexOf(id);
    },

    timeslotTimeline(timeSlot){
      let events = [];
      let appointments = getAppointmentsByTimeSlot(timeSlot);

      appointments.forEach(appointment => {
        events.push({datetime: appointment.datetime, free: false})
      });


      let freeTimes = freeTimeSlots[timeSlot.id]
    },

    /**
     * TODO:
     *  * `this.selectedDate` in this component but other params are in `newSlot`
     *  * `toISODate()` returns `2021-7-7`. it should return `2021-07-07`
     */
    async addNewSlot(newSlot) {
      let slot = {
        date: toISODate(this.selectedDate),
        start_time: `${newSlot.startTime.hour}:${newSlot.startTime.minutes}:00`,
        end_time: `${newSlot.endTime.hour}:${newSlot.endTime.minutes}:00`,
        interval: newSlot.interval,
        overlaps: newSlot.overlaps,
        capacity: newSlot.capacity,
        source: newSlot.source
      };
      try {
        await this.user.addDateTimeInterval(slot);
        this.addDateError = "";
        this.sourceError = "";

        // TODO: KY asked form to be prefilled
        // this.newStartTime = {
        //   hour: "",
        //   minutes: ""
        // };

        // reget all the slots
        await this.init();
      }
      catch (err) {
        this.addDateError = err.response.data.datetime;
        this.sourceError = err.response.data.source;
      }
    },

    async deleteDateInterval(id) {
      await this.user.deleteTimeInterval(id, this.getIndexOfTimeSlot(id));
    },

    async switchIsOpen(timeSlot, isOpen) {
      const resp = await timeSlot.update({ is_open: isOpen });
      this.freeTimeSlots = await this.user.getFreeTimeForSlots();
    },

    getSourceByTimeslotId(id) {
      let timeslot = this.timeSlots.find(slot => slot.id == id);

      if (!timeslot) {
        return '';
      }

      let source = this.appointmentSources.find(source => source.id == timeslot.source);

      if (!source) {
        return '';
      }

      return source.name;
    },
  },  // END: methods
};
</script>

<style lang="scss">
.timetable {
  box-sizing: border-box;
  &__calendar {
    padding: 50px 30px;
  }
  &__content {
    padding: 50px 40px;
    min-height: 940px;
    border-left: solid 2px $gray-lighter;
  }
  &__header {
    margin-bottom: 40px;
    .title {
      font-size: 28px;
      font-weight: 500;
      color: $black;
    }
  }
  &__list {
    margin-bottom: 20px;
    .header {
      background: $blue-light;
      min-height: 40px;
      span {
        white-space: nowrap;
      }
    }
  }
}
.timetable-card {
  min-height: 60px;
  border-bottom: solid 2px $gray-lighter;
  color: $gray;
  .btn-cancel {
    padding: 15px;
    cursor: pointer;
    display: none;
  }
  &:hover {
    .btn-cancel {
      display: inline-block;
    }
  }
}

.message--error {
  display: inline-block;
  margin-top: 20px;
}
</style>
